import React from 'react';
import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from 'next-seo';
import RoundedButton from 'components/RoundedButton';
import Separator from 'components/Separator';
import { getCta } from 'utils/common';

const Article = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/meet-our-10k-iceland-raffle-winner`;

  return (
    <MainLayout>
      <NextSeo
        title="Meet our £10k Iceland Raffle Winner | Win Epic Prizes | DAYMADE"
        description="James won a £10,000 DAYMADE holiday to Iceland for two! Will you be our next £10k prize winner? Enter now for your chance to win big."
        openGraph={{
          title:
            'Meet our £10k Iceland Raffle Winner | Win Epic Prizes | DAYMADE',
          description:
            'James won a £10,000 DAYMADE holiday to Iceland for two! Will you be our next £10k prize winner? Enter now for your chance to win big.',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/meet-our-10k-iceland-raffle-winner',
          images: [
            {
              url: `${IMAGE_DIRECTORY}/hero.jpg`,
              alt: 'The Skogafoss waterfall in Iceland under the Northern Lights',
            },
          ],
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'win a holiday to Iceland,win a trip to Iceland,win a prize,ion adventure hotel,northern lights holiday',
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText="The Skogafoss waterfall in Iceland under the Northern Lights"
        heroImageYPosition="10%"
      >
        <>
          <h1 style={{ fontSize: '1.6em', lineHeight: '1.4em' }}>
            Meet Our £10k Iceland Raffle Winner
          </h1>

          <p className="subheading">
            James won a £10k holiday to the land of fire and ice
          </p>

          <div
            className="separator"
            style={{ width: '80%', marginTop: 0 }}
          />

          <p
            style={{
              fontStyle: 'italic',
              textAlign: 'center',
              marginBottom: '2em',
            }}
          >
            by Abbi James
          </p>

          <p>
            In 2021 we hosted our biggest raffle yet – a £10,000 trip for two to
            Iceland! Here’s your chance to find out about our winner James and
            his upcoming Icelandic adventure…
          </p>

          <p>
            When the draw took place on 28th September 2021, we couldn’t wait to
            call our winner to congratulate them.{' '}
            <em>
              “I didn’t put my phone number down, so I got an email asking if I
              was available for a quick call. I thought hmm, it is real? Is it
              not?”
            </em>{' '}
            We assured him that yes, he really had won and this wasn’t a hoax!{' '}
            <em>
              “It made my day when I got a phone call from Callum to tell me I’d
              won!”
            </em>
          </p>

          <p>
            James was new to DAYMADE when he scored his big win:{' '}
            <em>
              “This was my second time entering anything with DAYMADE and I
              actually won! I won off one ticket – it cost me £7 to win!”
            </em>
            .
          </p>

          <p>
            The all-important question: who was the first to hear of James
            winning a £10,000 holiday to Iceland?{' '}
            <em>
              “The first person I told was the most important, which was my
              sausage dog Pablo!”
            </em>
            . Pablo might not be accompanying James on his Icelandic adventure,
            but we hope he’ll receive a pawsome postcard.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt="Two people enjoying champagne in a hot tub"
            className="singleBlogImage"
          />

          <p>
            James and his very lucky plus-one will be spending their time on
            unique adventures, remote explorations and unforgettable
            experiences. The highlight? They’ll be whisked off in a private Jeep
            to the dormant Þríhnúkagígur volcano, before enjoying a 4-course
            bespoke meal prepared by a personal chef. This really is a
            once-in-a-lifetime experience, and we couldn’t be more excited for
            them!{' '}
            <em>
              “I can’t wait to get there. One thing I’m looking forwards to the
              most is that we’re having a dinner in a dormant volcano…. When are
              you ever going to get to do that?! But thanks to DAYMADE it’s
              something that’s going to happen.”
            </em>
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
            alt="Lift within the dormant Þríhnúkagígur volcano"
            className="singleBlogImage"
          />

          <p>
            Whilst the private dinner inside a volcano is the undeniable
            highlight of his trip, James’ adventure will see him discovering the
            land of fire and ice over six days. The luxurious ION Adventure
            Hotel will be his base of exploration, set in majestic mountainous
            lava fields and surrounded by Iceland’s rich flora and fauna. The
            landscape of the Thingvellir area is home to a wide variety of
            species, from Greylag Geese to Arctic Char, Sticklebacks to the
            beloved Arctic Fox. Straight from the ION Adventure Hotel, daily
            expeditions range from horseback riding to snorkeling, hiking to
            snowmobile riding. Still in the early stages of planning his
            adventure, James has a few ideas for how to spend his time:{' '}
            <em>
              “We’re going to try going to the Blue Lagoon Spa, and we have a
              few other things sorted”
            </em>
            . It’s hard to choose with so many exciting options – we can’t wait
            to hear how they’ll spend their time.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
            alt="Woman swimming in a pool under the Northern Lights in Iceland"
            className="singleBlogImage"
          />

          <p>
            A trip to Iceland wouldn’t be complete without an expedition to see
            the Northern Lights, or Aurora Borealis. This natural phenomenon has
            drawn viewers to gaze upon the night sky for years, hoping to catch
            a glimpse of the colourful waves of light dancing on the horizon.
            Few phenomena capture the imagination like the Aurora Borealis, and
            with a little luck on his side, James will be ticking this one off
            his bucketlist in no time at all.
          </p>

          <p>
            We’re so excited for James to explore Iceland’s rich culture and
            stunning scenery. In February we took James and his plus one to The
            Morritt Country House Hotel and Garage Spa for a few nights of rest
            and relaxation to celebrate his epic win. It might not be Iceland’s
            Blue Lagoon Spa, but who can say no to a hot tub, steam room and spa
            treatment?
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary4.jpg`}
            alt="Man enjoying champagne in a hot tub"
            className="singleBlogImage"
          />

          <p>
            We realise it’s only natural for people to be a little sceptical
            about whether DAYMADE is real – after all, it’s not every day you
            win a £10,000 holiday! We asked James what he thought about DAYMADE
            and needless to say, we’re blushing now :’){' '}
            <em>
              “DAYMADE have been brilliant with me, really accommodating, really
              lovely… I couldn’t say anything better! Everyone I’ve told about
              DAYMADE have signed up because everyone knows I never win
              anything.”
            </em>
          </p>

          <p>
            We’re so excited for James to enjoy his epic £10,000 holiday for two
            to Iceland! His advice?{' '}
            <em>
              “People do actually win these prizes! I certainly thought no one
              actually wins those, but I’m one of the now-believers. I’ve won
              plenty of prizes! If any of you out there are wondering if you
              should enter, I’d say go for it! I’m certainly going to enter
              every other raffle now because you never know, you could be that
              lucky one going to Iceland like I am! Thanks to Callum, thanks to
              everyone at DAYMADE and good luck!”
            </em>
          </p>

          <p>We couldn’t have said it better ourselves. Thanks James!</p>

          <p>
            <em>
              P.S. For every entry into our Iceland Raffle, we donated a
              Mangrove tree to our charity partner SeaTrees. Thanks to you, a
              fantastic 1,340 trees were planted! You rock &lt;3
            </em>
          </p>

          <Separator style={{ margin: '1em 0 2.5em' }} />

          <p style={{ textAlign: 'center' }}>
            For your chance to win a holiday to Iceland, enter the DAYMADE
            Weekly Draws today.
          </p>

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px', margin: '1em 0 1.5em' }}
          >
            Enter Now
          </RoundedButton>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default Article;
